import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { SectionLayout } from ".";
import { SleepSummary2 } from "../commons/sleep_summaries_2";

interface MeasurementDataAverageSectionProps {
  measurement_data: SleepSummary2["sleep_condition"]["measurement_data"];
}
/**
 * 睡眠測定データの平均値
 *
 * @param props {@link MeasurementDataSectionProps}
 * @returns 睡眠の判定詳細
 */
export default function MeasurementDataAverageSection({
  measurement_data,
}: MeasurementDataAverageSectionProps) {
  return (
    <SectionLayout title="参考：睡眠測定データの平均値" border_color="black.36">
      <TableContainer
        sx={{
          border: "solid #E0E0E0",
          borderWidth: "1px 1px 0 1px",
        }}
      >
        <Table>
          <TableHead
            sx={{
              "& .MuiTableCell-root": {
                backgroundColor: "black.36",
                color: "white",
              },
            }}
          >
            <TableRow>
              <TableCell sx={{ width: "127px" }}>
                <Typography variant="subtitle2">項目</Typography>
              </TableCell>
              <TableCell
                sx={{
                  width: "127px",
                  paddingLeft: "0px",
                }}
              >
                <Typography
                  variant="subtitle2"
                  sx={{
                    borderLeft: "2px solid #FFFFFF1F",
                    paddingLeft: "16px",
                  }}
                >
                  今回結果
                </Typography>
              </TableCell>
              <TableCell
                sx={{
                  width: "127px",
                  paddingLeft: "0px",
                }}
              >
                <Typography
                  variant="subtitle2"
                  sx={{
                    borderLeft: "2px solid #FFFFFF1F",
                    paddingLeft: "16px",
                  }}
                >
                  前回結果
                </Typography>
              </TableCell>
              <TableCell
                sx={{
                  width: "127px",
                  paddingLeft: "0px",
                }}
              >
                <Typography
                  variant="subtitle2"
                  sx={{
                    borderLeft: "2px solid #FFFFFF1F",
                    paddingLeft: "16px",
                  }}
                >
                  前回との差
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell
                sx={{
                  borderRight: "1px solid #E0E0E0",
                }}
              >
                消灯時刻
              </TableCell>
              <TableCell>{measurement_data.bedtime.result || "-"}</TableCell>
              <TableCell>
                {measurement_data.bedtime.last_time_result || "-"}
              </TableCell>
              <TableCell>{measurement_data.bedtime.diff || "-"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell
                sx={{
                  borderRight: "1px solid #E0E0E0",
                }}
              >
                起床時刻
              </TableCell>
              <TableCell>{measurement_data.arise_time.result || "-"}</TableCell>
              <TableCell>
                {measurement_data.arise_time.last_time_result || "-"}
              </TableCell>
              <TableCell>{measurement_data.arise_time.diff || "-"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell
                sx={{
                  borderRight: "1px solid #E0E0E0",
                }}
              >
                睡眠時間
              </TableCell>
              <TableCell>{measurement_data.sleep_time.result || "-"}</TableCell>
              <TableCell>
                {measurement_data.sleep_time.last_time_result || "-"}
              </TableCell>
              <TableCell>{measurement_data.sleep_time.diff || "-"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell
                sx={{
                  borderRight: "1px solid #E0E0E0",
                }}
              >
                睡眠効率
              </TableCell>
              <TableCell>
                {measurement_data.sleep_efficiency.result || "-"}
              </TableCell>
              <TableCell>
                {measurement_data.sleep_efficiency.last_time_result || "-"}
              </TableCell>
              <TableCell>
                {measurement_data.sleep_efficiency.diff || "-"}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell
                sx={{
                  borderRight: "1px solid #E0E0E0",
                }}
              >
                入眠潜時
              </TableCell>
              <TableCell>
                {measurement_data.sleep_latency.result || "-"}
              </TableCell>
              <TableCell>
                {measurement_data.sleep_latency.last_time_result || "-"}
              </TableCell>
              <TableCell>
                {measurement_data.sleep_latency.diff || "-"}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell
                sx={{
                  borderRight: "1px solid #E0E0E0",
                }}
              >
                中途覚醒時間
              </TableCell>
              <TableCell>
                {measurement_data.awakening_time.result || "-"}
              </TableCell>
              <TableCell>
                {measurement_data.awakening_time.last_time_result || "-"}
              </TableCell>
              <TableCell>
                {measurement_data.awakening_time.diff || "-"}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </SectionLayout>
  );
}
